import { BreakpointObserver, MediaMatcher } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { CoreService } from 'src/app/services/core.service';
import { AppSettings } from 'src/app/config';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { navItems } from './vertical/sidebar/sidebar-data';
import { NavItem } from './vertical/sidebar/nav-item/nav-item';
import { NavService } from '../../services/nav.service';
import { AuthService } from '../../services/auth.service';
import { NotificationCenterService } from '../../services/notification-center.service';
import { FeatureService } from '../../services/feature.service';
import { AppNavItemComponent } from './vertical/sidebar/nav-item/nav-item.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './vertical/sidebar/sidebar.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TablerIconsModule } from 'angular-tabler-icons';
import { HeaderComponent } from './vertical/header/header.component';
import { AppHorizontalHeaderComponent } from './horizontal/header/header.component';
import { AppHorizontalSidebarComponent } from './horizontal/sidebar/sidebar.component';
import { AppBreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { CustomizerComponent } from './shared/customizer/customizer.component';
import { AppFooterComponent } from './shared/footer/footer.component';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';
const BELOWMONITOR = 'screen and (max-width: 1023px)';

// for mobile app sidebar
interface apps {
  id: number;
  icon: string;
  color: string;
  title: string;
  subtitle: string;
  link: string;
}

interface quicklinks {
  id: number;
  title: string;
  link: string;
}

@Component({
  selector: 'app-full',
  imports: [
    RouterModule,
    AppNavItemComponent,
    MaterialModule,
    CommonModule,
    SidebarComponent,
    NgScrollbarModule,
    TablerIconsModule,
    HeaderComponent,
    AppHorizontalHeaderComponent,
    AppHorizontalSidebarComponent,
    AppBreadcrumbComponent,
    CustomizerComponent,
    AppFooterComponent
  ],
  templateUrl: './full.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None,
})
export class FullComponent implements OnInit {
  navItems: NavItem[] = [];

  @ViewChild('leftsidenav')
  public sidenav: MatSidenav;
  resView = false;
  selectedIcon = 1;

  @ViewChild('content', { static: true }) content!: MatSidenavContent;
  //get options from service
  options = this.settings.getOptions();
  private layoutChangesSubscription = Subscription.EMPTY;
  private isMobileScreen = false;
  private isContentWidthFixed = true;
  private isCollapsedWidthFixed = false;
  private htmlElement!: HTMLHtmlElement;


  isFilterNavOpen: boolean = false;

  get isOver(): boolean {
    return this.isMobileScreen;
  }

  get isTablet(): boolean {
    return this.resView;
  }

  // Raccourcis applicatifs Dinki (header app menu)
  apps: apps[] = [
    {
      id: 1,
      icon: 'solar:users-group-two-rounded-line-duotone',
      color: 'primary',
      title: 'Clients',
      subtitle: 'Gérer ma clientèle',
      link: '/dinki/clients',
    },
    {
      id: 2,
      icon: 'solar:ruler-line-duotone',
      color: 'success',
      title: 'Mesures',
      subtitle: 'Carnet de mesures',
      link: '/dinki/mesures',
    },
    {
      id: 3,
      icon: 'solar:palette-line-duotone',
      color: 'warning',
      title: 'Modèles',
      subtitle: 'Catalogue de modèles',
      link: '/dinki/modeles',
    },
    {
      id: 4,
      icon: 'solar:crown-line-duotone',
      color: 'error',
      title: 'Abonnement',
      subtitle: 'Plan et paiement',
      link: '/dinki/abonnement',
    },
    {
      id: 5,
      icon: 'solar:refresh-line-duotone',
      color: 'secondary',
      title: 'Synchronisation',
      subtitle: 'Sauvegardes & sync',
      link: '/dinki/sync',
    },
    {
      id: 6,
      icon: 'solar:shop-line-duotone',
      color: 'primary',
      title: 'Mon atelier',
      subtitle: 'Profil de l\'atelier',
      link: '/dinki/atelier',
    },
  ];

  quicklinks: quicklinks[] = [
    { id: 1, title: 'Tableau de bord', link: '/dinki/dashboard' },
    { id: 2, title: 'Clients', link: '/dinki/clients' },
    { id: 3, title: 'Mesures', link: '/dinki/mesures' },
    { id: 4, title: 'Modèles', link: '/dinki/modeles' },
    { id: 5, title: 'Mon atelier', link: '/dinki/atelier' },
    { id: 6, title: 'Abonnement', link: '/dinki/abonnement' },
  ];

  onIconSelected(icon: number) {
    this.selectedIcon = icon;
  }

  constructor(
    private settings: CoreService,
    private mediaMatcher: MediaMatcher,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private navService: NavService,
    private auth: AuthService,
    private notifCenter: NotificationCenterService,
    private featureSvc: FeatureService,
  ) {
    this.refreshNavItems();
    this.auth.user$.subscribe(() => this.refreshNavItems());
    // Le menu se rafraîchit aussi quand les features de l'utilisateur changent
    this.featureSvc.watch().subscribe(() => this.refreshNavItems());
    // Démarre le polling des notifications dès qu'on entre dans le layout
    if (this.auth.isLoggedIn) {
      this.notifCenter.startPolling();
    }
    this.htmlElement = document.querySelector('html')!;
    this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW, BELOWMONITOR])
      .subscribe((state) => {
        // SidenavOpened must be reset true when layout changes
        this.options.sidenavOpened = true;
        this.isMobileScreen = state.breakpoints[BELOWMONITOR];
        if (this.options.sidenavCollapsed == false) {
          this.options.sidenavCollapsed = state.breakpoints[TABLET_VIEW];
        }
        this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
        this.resView = state.breakpoints[BELOWMONITOR];
      });

    // Initialize project theme with options
    this.receiveOptions(this.options);

    // This is for scroll to top
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((e) => {
        this.content.scrollTo({ top: 0 });
      });
  }

  ngOnInit(): void {
    // Charge le snapshot des features de l'utilisateur courant : peuple le
    // menu (items gated) et sert de cache au featureGuard. Le watch() plus
    // haut rafraîchit la navigation dès que les données arrivent.
    this.featureSvc.ensureLoaded().subscribe({ error: () => {} });
  }

  /**
   * Filtre les items de navigation selon le rôle de l'utilisateur courant
   * et la matrice des features actives, puis nettoie les sections "vides" :
   *  - retire les en-têtes ({@code navCap} / {@code divider}) consécutifs
   *  - retire les en-têtes qui ne sont plus suivis d'aucun item navigable
   * Ainsi, un ADMIN ne voit pas l'en-tête "Atelier" si aucun item de la
   * section ne lui est destiné, et un atelier sans la feature de
   * facturation ne voit pas les items qui en dépendent.
   */
  private refreshNavItems(): void {
    const role = this.auth.currentRole();
    const allowed = navItems.filter((item) => {
      if (item.roles && !item.roles.includes(role)) return false;
      if (item.feature && !this.featureSvc.isEnabled(item.feature)) return false;
      return true;
    });

    const cleaned: NavItem[] = [];
    for (const item of allowed) {
      const isHeader = !!item.navCap || !!item.divider;
      if (isHeader) {
        // Retire les en-têtes consécutifs (n'en garde qu'un)
        const last = cleaned[cleaned.length - 1];
        if (last && (last.navCap || last.divider)) {
          cleaned.pop();
        }
        cleaned.push(item);
      } else {
        cleaned.push(item);
      }
    }

    // Retire les en-têtes en fin de liste sans contenu en dessous
    while (
      cleaned.length > 0 &&
      (cleaned[cleaned.length - 1].navCap || cleaned[cleaned.length - 1].divider)
    ) {
      cleaned.pop();
    }

    this.navItems = cleaned;
  }

  ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
  }

  openClosedMenu() {
    this.options.sidenavCollapsed = false;
    this.resetCollapsedState();
  }

  toggleCollapsed() {
    this.isContentWidthFixed = false;
    this.options.sidenavCollapsed = !this.options.sidenavCollapsed;
    this.resetCollapsedState();
  }

  resetCollapsedState(timer = 400) {
    setTimeout(() => this.settings.setOptions(this.options), timer);
  }

  onSidenavClosedStart() {
    this.isContentWidthFixed = false;
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.isCollapsedWidthFixed = !this.isOver;
    this.options.sidenavOpened = isOpened;
    this.settings.setOptions(this.options);
  }

  receiveOptions(options: AppSettings): void {
    this.toggleDarkTheme(options);
    this.toggleColorsTheme(options);
  }

  toggleDarkTheme(options: AppSettings) {
    if (options.theme === 'dark') {
      this.htmlElement.classList.add('dark-theme');
      this.htmlElement.classList.remove('light-theme');
    } else {
      this.htmlElement.classList.remove('dark-theme');
      this.htmlElement.classList.add('light-theme');
    }
  }

  toggleColorsTheme(options: AppSettings) {
    // Remove any existing theme class dynamically
    this.htmlElement.classList.forEach((className) => {
      if (className.endsWith('_theme')) {
        this.htmlElement.classList.remove(className);
      }
    });

    // Add the selected theme class
    this.htmlElement.classList.add(options.activeTheme);
  }
}
